import classcat from "classcat";
import React from "react";

import { ProductPrice, ProductPriceWithRange } from "@is/types";
import { convertCurrencyCodeToSymbol } from "@is/utils";

import css from "./Price.module.css";

type Props = {
  price: ProductPrice | ProductPriceWithRange;
  className?: string;
};

const Price = ({ price, className }: Props) => (
  <div className={classcat([className, css.container])}>
    <strong>
      <span
        className={classcat([
          css.retailPrice,
          { [css.sale]: !!price.salePrice },
        ])}
      >
        {`${price.retailPrice} ${convertCurrencyCodeToSymbol(
          price.currencyCode
        )}`}
      </span>
      {!!price.salePrice && (
        <span className={css.salePrice}>{`${
          price.salePrice
        } ${convertCurrencyCodeToSymbol(price.currencyCode)}`}</span>
      )}
    </strong>
  </div>
);

export default Price;
